module.exports = __webpack_public_path__ + "static/media/relaxmit-1.55f3a6fc.jpg";